import React, { useEffect, forwardRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useForm } from 'react-hook-form';
import PropTypes from 'prop-types';
import { yupResolver } from '@hookform/resolvers/yup';
import i18n from 'i18n';
import { ERROR_PAGE } from 'constants/IncorporationConstants';
import FormTitle from 'components/IncorporationOfTerms/Register/FormAtoms/FormTitle';
import TblRowHeader from 'components/IncorporationOfTerms/Register/FormAtoms/TblRowHeader';
import TblRow from 'components/IncorporationOfTerms/Register/FormAtoms/TblRow';
import { InstantOfTermsSchema } from 'components/IncorporationOfTerms/IncorporationOfTermsSchema';
import Form from 'components/IncorporationOfTerms/Register/FormMolecules/Form';
import PasswordForm from 'components/IncorporationOfTerms/Register/FormMolecules/PasswordForm';
import NameForm from 'components/IncorporationOfTerms/Register/FormMolecules/NameForm';
import ResidenceCntry from 'components/IncorporationOfTerms/Register/FormMolecules/ResidenceCntry';
import PasswordInput from 'components/IncorporationOfTerms/Register/FormMolecules/PasswordInput';
import Terms from 'components/IncorporationOfTerms/Terms/Terms';
import * as instantsActions from 'redux/ducks/Employee/InstantDucks';

// [8.0] 02_id 즉시발급을 통한 가입
// 미사용!

export const InstantRegister = ({ langCd, onValidationChange }, ref) => {
  const dispatch = useDispatch();
  const { isCheckPwSuccess, employeeVo } = useSelector(state => state.instant);
  const { residenceCntry, termsContents } = useSelector(state => state.terms);

  const InstantFormMethods = useForm({
    mode: 'onChange',
    resolver: yupResolver(InstantOfTermsSchema()),
  });
  const {
    formState: { isValid },
  } = InstantFormMethods;
  useEffect(() => {
    onValidationChange(isValid);
  }, [isValid, onValidationChange]);
  useEffect(() => {
    dispatch(instantsActions.getLoginUser());
  }, []);

  useEffect(() => {
    if (!employeeVo) {
      window.location.href = ERROR_PAGE;
    }
  }, [employeeVo]);

  const onSubmit = values => {
    dispatch(instantsActions.checkPassword({ userId: employeeVo.userId, pwd: values.cnpwd }));
  };

  useEffect(() => {
    if (isCheckPwSuccess) {
      const pslInfoAgmts = [];
      termsContents.map(item => {
        pslInfoAgmts.push({
          trmsCd: item.trmsCd,
          trmsVerVal: item.trmsVerVal,
          agmtYn: InstantFormMethods.getValues(`${item.trmsCd}`) ? 'Y' : 'N',
        });
      });

      dispatch(
        instantsActions.updateEmployee({
          epid: employeeVo.epId,
          userId: employeeVo.userId,
          compCd: employeeVo.compCd,
          pwd: InstantFormMethods.getValues('pwd'),
          confirmPwd: InstantFormMethods.getValues('pwdConfirm'),
          snm: InstantFormMethods.getValues('snm'),
          gnm: InstantFormMethods.getValues('gnm'),
          fnm: InstantFormMethods.getValues('fnm'),
          jobplAddrCntryCd: residenceCntry.value,
          xtnlEmailAddr: employeeVo.userId,
          emailAddr: employeeVo.userId,
          rlnmYn: employeeVo.rlnmYn,
          dn: employeeVo.dn,
          pslInfoAgmts,
          emmtTypeCd: 'N',
          deptCd: 'TOP',
          secuGrdCd: '5',
        }),
      );
    }
  }, [isCheckPwSuccess]);

  return (
    <>
      <Form formControl={InstantFormMethods} handleSubmit={onSubmit} ref={ref}>
        <div className="form-section">
          <ul className="form-table">
            <FormTitle title="MB_T_INFORMATION" isRequired />
            <TblRow>
              <TblRowHeader rowHeader="ID" isRequired />
              <div className="form-field">
                <p className="text-box">{employeeVo.userId}</p>
              </div>
            </TblRow>
            <PasswordInput pwdName="cnpwd" label="MB_T_ID_OLDPASS" placeholderLabel={i18n.t('MB_T_PW_HOLDER')} />
            <PasswordForm isNew />
            <NameForm />
            <ResidenceCntry />
          </ul>
          <ul className="form-table">
            <Terms />
          </ul>
        </div>
      </Form>
    </>
  );
};

InstantRegister.propTypes = { langCd: PropTypes.string, onValidationChange: PropTypes.func };
InstantRegister.defaultProps = { langCd: 'ko', onValidationChange: () => {} };

export default forwardRef(InstantRegister);
